import { createSlice } from "@reduxjs/toolkit";

export interface BowtieState {
  isLoading: boolean;
}

export const bowtieSlice = createSlice({
  name: "bowtie",

  initialState: {
    isLoading: true,
  } as BowtieState,

  reducers: {
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});
